import { render, staticRenderFns } from "./StepBoxes.vue?vue&type=template&id=00bd401a&scoped=true"
import script from "./StepBoxes.vue?vue&type=script&lang=js"
export * from "./StepBoxes.vue?vue&type=script&lang=js"
import style0 from "./StepBoxes.vue?vue&type=style&index=0&id=00bd401a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd401a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00bd401a')) {
      api.createRecord('00bd401a', component.options)
    } else {
      api.reload('00bd401a', component.options)
    }
    module.hot.accept("./StepBoxes.vue?vue&type=template&id=00bd401a&scoped=true", function () {
      api.rerender('00bd401a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/reportbuilder/StepBoxes.vue"
export default component.exports